import React, {PropTypes} from 'react';
import Link from 'shared/Link.jsx';
import TournamentListContainer from '../tournamentList/TournamentListContainer.jsx';
import TournamentSearchContainer from '../tournamentList/TournamentSearchContainer.jsx';
import ShowAllTournamentsCheckboxContainer from './ShowAllTournamentsCheckboxContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const SetupHome = ({
  activeTournamentCount,
  loadingTournaments,
  entries,
  groupName,
  onPartnerLoginClick,
  onExitPartnerClick,
  isAllowed,
  permissions
}) => {
  let canMigratePartnersFromV2 = permissions.find(permission => permission === "CanMigratePartnersFromV2");

  return( 
    <div className="flex center animated fadeIn">
      <div className="col-xs-12 col-lg-8">
        <DisplayIf condition={isAllowed && canMigratePartnersFromV2 && groupName != undefined && groupName !== ''}>
          <div className="col-xs-12">
            <div className="alert alert-danger text-center">
              <div className="row">
                <div className="col-xs-3 text-left cursor-pointer" style={{fontSize: '10px', fontWeight: 'bold'}}>
                  <button onClick={onPartnerLoginClick}>
                    <i className="fa fa-user" />{` Manage another Partner Hub`}
                  </button>
                </div>
                <div className="col-xs-6 text-center">
                  You are managing tournaments for {groupName}
                </div>
                <div className="col-xs-3 text-right cursor-pointer" style={{fontSize: '10px', fontWeight: 'bold'}}>
                  <button onClick={onExitPartnerClick}>
                    <i className="fa fa-sign-out" />{` Exit Partner Hub Mode`}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </DisplayIf>

        <div className="text-right">
          <Link
            to="tournament/create"
            className="btn btn-primary btn-lg"
          >{`Create New Tournament`}</Link>
        </div>
          <br />
          <ShowAllTournamentsCheckboxContainer />
          <br />
          {activeTournamentCount > 6 ? <TournamentSearchContainer /> : null}
          {
            loadingTournaments
              ? <div className="alert alert-info">{'Loading tournament data.'}</div>
              : <div>
                {
                  (!entries || entries.length === 0) ?
                    <div className="alert alert-info">{'No tournaments found.'}</div>:
                    <TournamentListContainer /> 
                }
              </div>
          }
        </div>
    </div>
  );
};

SetupHome.propTypes = {
  activeTournamentCount: PropTypes.number,
  loadingTournaments: PropTypes.bool,
  entries: PropTypes.arrayOf(PropTypes.object),
  groupName: PropTypes.string,
  onPartnerLoginClick: PropTypes.func,
  onExitPartnerClick: PropTypes.func,
  isAllowed: PropTypes.bool
};

SetupHome.defaultProps = {
  entries: [],
  activeTournamentCount: 0
};

export default SetupHome;



// WEBPACK FOOTER //
// ./src/features/tournament/home/SetupHome.jsx